import CheckIcon from "@mui/icons-material/Done";
import UnCheckIcon from "@mui/icons-material/Close";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import {
  // eslint-disable-next-line no-unused-vars
  GridCellProps,
  GRID_COL_INDEX_ATTRIBUTE,
} from "@progress/kendo-react-grid";
/**
 *
 * @param {GridCellProps} props
 * @returns
 */
const BooleanCell = (props) => {
  const field = props.field || "";
  const value = props.dataItem[field];
  const navigationAttributes = useTableKeyboardNavigation(props.id);
  const returnIcon = () => {
    if (value === "EVET" || value === true || value === "AKTIF")
      return <CheckIcon />;
    if (value === "HAYIR" || value === false || value === "PASIF")
      return <UnCheckIcon />;
    return "";
  };
  return (
    <td
      aria-selected={props.isSelected}
      colSpan={props.colSpan}
      aria-colindex={props.ariaColumnIndex}
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
      {...navigationAttributes}
    >
      {returnIcon()}
    </td>
  );
};
export default BooleanCell;
